import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchAirlineOffComponent } from './search-airline-off.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SearchAirlineOffComponent],
  imports: [CommonModule, NgSelectModule, FormsModule],
  exports: [SearchAirlineOffComponent]
})
export class SearchAirlineOffModule { }
